import ContratApi from '@/api/contrats';
import StoreBuilder from '../store-builder';

const builder = new StoreBuilder('contrats');
builder.addStatePart('contrats', [], param => ContratApi.getAllContratsByTiers(param), 'NONE', 60);

export default builder.build();
